import { gql } from '@apollo/client';

export const CREATE_PRAYER_MEETING = gql`
    mutation CreatePrayerMeeting($supportedOrganisationId: Int!, $name: String!, $location: String, $time: String, $frequency: String) {
        createPrayerMeeting(supportedOrganisationId: $supportedOrganisationId, name: $name, location: $location, time: $time, frequency: $frequency) {
            id
            name
            location
            time
            frequency
        }
    }
`;
